module.exports = __webpack_public_path__ + "img/ms-symbollockup_signin_dark.8bcfc925.svg";